/**
 * [translateTime  剩余时间戳转为剩余天时分秒]
 * @param   {number}  time  [时间戳]
 * @return  {string}  [剩余天时分秒]
 */
export function translateTime(time) {
  let days = time / 1000 / 60 / 60 / 24
  let daysRound = Math.floor(days)
  let hours = time / 1000 / 60 / 60 - 24 * daysRound
  let hoursRound = Math.floor(hours)
  let minutes = time / 1000 / 60 - 24 * 60 * daysRound - 60 * hoursRound
  let minutesRound = Math.floor(minutes)
  // let seconds = time / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound)
  if (daysRound !== 0) {
    return daysRound + '天' + hoursRound + '时' + minutesRound + '分'
  } else if (hoursRound !== 0) {
    return hoursRound + '时' + minutesRound + '分'
  } else if (minutesRound !== 0) {
    return minutesRound + '分'
  } else {
    return time / 1000 + '秒'
  }
}

/**
 * [formatDate  时间戳转为年月日时分秒]
 * @param   {object}  time  [时间对象]
 * @param   {string}  sign  [需要转换的类型，默认为date]
 * @return  {string}  [年月日时分秒]
 */
export function formatDate(time, sign = 'date') {
  var date = new Date(Number(time))
  let Y = date.getFullYear() + '-'
  let M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let s = date.getSeconds() < 10 ? ':' + '0' + date.getSeconds() : ':' + date.getSeconds()
  if (sign === 'date') {
    return Y + M + D
  } else if (sign === 'time') {
    return h + m
  } else if (sign === 'half') {
    return Y + M + D + ' ' + h
  } else if (sign === 'total') {
    return Y + M + D + ' ' + h + m
  } else if (sign === 'all') {
    return Y + M + D + ' ' + h + m + s
  } else if (sign === 'allTime') {
    return h + m + s
  }
}

/*
 * js对象深拷贝
 * @param  {Object} obj 被拷贝的对象
 * @return {Object} 返回新对象
 */
export function deepCopy(obj, cache = []) {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = cache.filter(c => c.original === obj)[0]
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })
  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

// 版本转化code
export function versioncodeFormat(code) {
  if (!code) {
    return 0
  }
  return Number(code.split('.').map(i => i.padStart(3, '0')).join().replace(/,/g, ''))
}
// 获取地址栏参数
export function getUrlParams(name, origin = null) {
  let url = location.href
  let temp1 = url.split('?')
  let pram = temp1[1] || []
  let keyValue = pram.split('&')
  let obj = {}
  for (let i = 0; i < keyValue.length; i++) {
    let item = keyValue[i].split('=')
    let key = item[0]
    let value = item[1]
    obj[key] = value
  }
  return obj[name]
}


// WEBPACK FOOTER //
// ./src/utils/index.js